import { combineReducers } from 'redux';

import * as actionTypes from '@store/material/action-types';

const getGarmentsDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_GARMENTS_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_GARMENTS_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getFabricDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_FABRIC_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getEmbellishmentDetails = (state = null, { type }) => {
	switch (type) {
		case actionTypes.FETCH_EMBELLISHMENT_DETAILS_SUCCESS:
		case actionTypes.FETCH_EMBELLISHMENT_DETAILS_FAILURE:
			return state;
		default:
			return state;
	}
};

const getTrimsDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_TRIMS_DETAILS_SUCCESS:
			return payload;
		case actionTypes.FETCH_TRIMS_DETAILS_FAILURE:
			return state;
		default:
			return state;
	}
};

const getBrandingDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BRANDING_DETAILS_SUCCESS:
			return payload;
		case actionTypes.FETCH_BRANDING_DETAILS_FAILURE:
			return state;
		default:
			return state;
	}
};

const getWashingDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_WASHING_DETAILS_SUCCESS:
			return payload;
		case actionTypes.FETCH_WASHING_DETAILS_FAILURE:
			return state;
		default:
			return state;
	}
};

const getMaterialDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_MATERIALS_DETAILS_SUCCESS:
			return payload;
		case actionTypes.FETCH_MATERIALS_DETAILS_FAILURE:
			return state;
		default:
			return state;
	}
};

const initialState = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getMaterialSuppliers = (state = initialState, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_MATERIAL_SUPPLIERS_FAILURE:
			return state;
		case actionTypes.FETCH_MATERIAL_SUPPLIERS_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_MORE_MATERIAL_SUPPLIERS_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		default:
			return state;
	}
};

const getPinnedMaterials = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_PINNED_MATERIALS_FAILURE:
			return state;
		case actionTypes.FETCH_PINNED_MATERIALS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const materialReducer = combineReducers({
	garmentsDetails: getGarmentsDetails,
	fabricDetails: getFabricDetails,
	embellishmentDetails: getEmbellishmentDetails,
	trimsDetails: getTrimsDetails,
	brandingDetails: getBrandingDetails,
	washingDetails: getWashingDetails,
	materialDetails: getMaterialDetails,
	materialSuppliers: getMaterialSuppliers,
	pinnedMaterials: getPinnedMaterials
});

export default materialReducer;
